/***
 * ZDE BY MELI BYT DEKLAROVANY VESKERE KLICE OD FINALTABLE a ROWSDATA
 * POPROSÍM NEPOUŽÍVAT VŠUDE JEDEN KLÍČ JAKO MAJÍ JINÉ APKY
 */
export const DAVKY_DTM_FT_KEY = 'DAVKY_DTM_FT_KEY';
export const DTM_ZARIZENI_FT_KEY = 'DTM_ZARIZENI_FT_KEY';
export const ATTRIBUTE_TABLE_FT_KEY = 'ATTRIBUTE_TABLE_FT_KEY';
export const CLIENT_ATTRIBUTE_TABLE_FT_KEY = 'CLIENT_ATTRIBUTE_TABLE_FT_KEY';
